import Vue from 'vue'

Vue.filter('hideRealPhone', value => {
  if (!value || value.length !== 11 || isNaN(+value)) {
    return value
  }
  const patten = /(\d{3})\d*(\d{4})/
  return value.toString().replace(patten, '$1****$2')
})